import { db, storage } from "../firebase";
import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  serverTimestamp,
  increment,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const COLECCION = "propiedades";

// ─── PÚBLICA ─────────────────────────────────────────────────────────────────
// Solo devuelve propiedades con estado "Disponible"
export async function getPropiedades() {
  const q = query(
    collection(db, COLECCION),
    where("estado", "==", "Disponible")
  );
  const snapshot = await getDocs(q);
  const docs = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
  return docs.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
}

// ─── ADMIN ───────────────────────────────────────────────────────────────────
// Devuelve TODAS las propiedades sin filtrar ni orderBy (para el panel admin)
export async function getPropiedadesAdmin() {
  const snapshot = await getDocs(collection(db, COLECCION));
  const docs = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
  return docs.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
}

// ─── UNA PROPIEDAD ───────────────────────────────────────────────────────────
export async function getPropiedad(id) {
  const docRef = doc(db, COLECCION, id);
  const snap = await getDoc(docRef);
  if (!snap.exists()) throw new Error("Propiedad no encontrada");
  return { id: snap.id, ...snap.data() };
}

// ─── REGISTRAR VISITA ────────────────────────────────────────────────────────
export async function registrarVisita(id) {
  try {
    const docRef = doc(db, COLECCION, id);
    await updateDoc(docRef, { visitas: increment(1) });
  } catch (err) {
    console.warn("No se pudo registrar la visita:", err);
  }
}

// ─── CREAR ───────────────────────────────────────────────────────────────────
export async function crearPropiedad(datos) {
  return await addDoc(collection(db, COLECCION), {
    ...datos,
    visitas: 0,
    createdAt: serverTimestamp(),
  });
}

// ─── EDITAR ──────────────────────────────────────────────────────────────────
export async function editarPropiedad(id, datos) {
  const docRef = doc(db, COLECCION, id);
  return await updateDoc(docRef, {
    ...datos,
    updatedAt: serverTimestamp(),
  });
}

// ─── ELIMINAR ────────────────────────────────────────────────────────────────
export async function eliminarPropiedad(id) {
  const docRef = doc(db, COLECCION, id);
  return await deleteDoc(docRef);
}

// ─── SUBIR IMÁGENES ──────────────────────────────────────────────────────────
export async function subirImagenes(archivos) {
  const urls = await Promise.all(
    archivos.map(async (archivo) => {
      const nombreUnico = `propiedades/${Date.now()}_${archivo.name}`;
      const storageRef = ref(storage, nombreUnico);
      await uploadBytes(storageRef, archivo);
      return await getDownloadURL(storageRef);
    })
  );
  return urls;
}